import axiosInstance from './AxiosInstance';

export const accreditationPrintingService = {
  // Upload template background file (image or PDF)
  uploadTemplateMedia: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post('/accred-printing/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Save or update template with coordinates JSON
  saveTemplate: async (payload) => {
    const response = await axiosInstance.post('/accred-printing/save', payload);
    return response.data;
  },

  // Get all templates with pagination and search
  getTemplates: async (params = {}) => {
    const response = await axiosInstance.get('/accred-printing/list', { params });
    return response.data;
  },

  // Get template by ID
  getTemplateById: async (id) => {
    const response = await axiosInstance.get(`/accred-printing/${id}`);
    return response.data;
  },

  // Get active template by user type ID
  getTemplateByUserType: async (userTypeId) => {
    const response = await axiosInstance.get(`/accred-printing/by-user-type/${userTypeId}`);
    return response.data;
  },

  // Delete template
  deleteTemplate: async (id) => {
    const response = await axiosInstance.delete(`/accred-printing/${id}`);
    return response.data;
  },

  // Eligible user count + template coverage for a parent (and optional user) type
  getUsersCount: async (params) => {
    const response = await axiosInstance.get('/accred-printing/users-count', { params });
    return response.data;
  },

  // Single card PDF as a Blob (preview a real user)
  renderOne: async (registrationId, params = {}) => {
    const response = await axiosInstance.get(`/accred-printing/render-one/${registrationId}`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  // Fields the Add-User form captures that a card can print
  getPrintFields: async () => (await axiosInstance.get('/accred-printing/fields')).data,

  // Skeleton bytes through the API (avoids S3 CORS when reopening a PDF template)
  getTemplateFile: async (id) =>
    (await axiosInstance.get(`/accred-printing/${id}/file`, { responseType: 'blob' })).data,

  // A few eligible users of a type, for "test with real user"
  getSampleUsers: async (params) => {
    const response = await axiosInstance.get('/accred-printing/sample-users', { params });
    return response.data;
  },

  // Bulk ZIP runs as a background job: start -> poll status -> fetch file
  startZipJob: async (body) => (await axiosInstance.post('/accred-printing/zip-jobs', body)).data,
  getZipJob: async (jobId) => (await axiosInstance.get(`/accred-printing/zip-jobs/${jobId}`)).data,
  cancelZipJob: async (jobId) => (await axiosInstance.delete(`/accred-printing/zip-jobs/${jobId}`)).data,
  downloadZipFile: async (jobId) =>
    (await axiosInstance.get(`/accred-printing/zip-jobs/${jobId}/file`, { responseType: 'blob', timeout: 0 })).data,

  // Email (or re-send) a person their accreditation card as a PDF
  emailCard: async (registrationId) => (await axiosInstance.post(`/accred-printing/email-card/${registrationId}`)).data,

  // Fetch Parent Types (user_category_type)
  getParentTypes: async () => {
    try {
      const response = await axiosInstance.get('/user-type');
      return response.data?.data || response.data || [];
    } catch (error) {
      console.error('Error fetching parent types:', error);
      return [];
    }
  },

  // Fetch User Sub Types (user_category_sub_type)
  getUserSubTypes: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/user-sub-type/all', { params: { limit: 1000, ...params } });
      return response.data?.data || response.data || [];
    } catch (error) {
      console.error('Error fetching user types:', error);
      return [];
    }
  },
};

export default accreditationPrintingService;
